import { eventLogger } from 'services/eventLogger.service'
import { googleAnalyticsLogger } from 'services/googleAnalytics.service'
import { ScreenName, TimeInterval } from 'root-constants'
import { PaymentMethod } from 'modules/purchase/constants'
import { TProductId } from 'models/subscriptions.model'

const enum FacebookPixelEvents {
  PURCHASE = 'Purchase',
  SUBSCRIBE = 'Subscribe',
  START_TRIAL = 'StartTrial',
}
function handleLogFacebookPixelEvent(
  price: number,
  subscriptionId: string,
  uuid: string,
  eventType: string,
  currency: string,
): void {
  window.fbq(
    'track',
    eventType,
    {
      value: price,
      currency,
      subscription_id: subscriptionId,
      subscription_sid: subscriptionId,
    },
    { eventID: uuid },
  )
}

function handleLogPurchaseCompleted({
  productId,
  price,
  paymentMethod,
  currency,
  screenName,
  isTrialActive,
}: {
  productId: string
  price: number
  paymentMethod: PaymentMethod
  currency: string
  screenName: ScreenName
  isTrialActive?: boolean
}): void {
  eventLogger.logPurchaseCompleted({
    productId,
    priceDetails: {
      price,
      currency,
      trial: isTrialActive,
    },
    paymentMethod,
    screenName,
  })
}

function handleLogGoogleAnalyticsEvent(
  subscriptionId: string,
  price: number,
  periodName: TimeInterval | null,
  periodQuantity: number | null,
  currency: string,
  screenName: ScreenName,
): void {
  googleAnalyticsLogger.logPurchaseCompleted({
    subscriptionId,
    price,
    periodName,
    periodQuantity,
    currency,
    screenName,
  })
}

export const logSuccessfulPayPalPayment = ({
  productId,
  price,
  subscriptionId,
  uuid,
  periodName,
  periodQuantity,
  paymentMethod,
  currency,
  trialPrice,
  trialPeriodDays,
  screenName,
  isTrialActive,
}: {
  productId: TProductId
  price: number
  subscriptionId: string
  uuid: string
  periodName: TimeInterval | null
  periodQuantity: number | null
  paymentMethod: PaymentMethod
  currency: string
  trialPrice: number
  trialPeriodDays: number
  screenName: ScreenName
  isTrialActive?: boolean
}): void => {
  handleLogFacebookPixelEvent(
    trialPeriodDays ? trialPrice : price,
    subscriptionId,
    uuid,
    FacebookPixelEvents.PURCHASE,
    currency,
  )
  handleLogFacebookPixelEvent(
    trialPeriodDays ? trialPrice : price,
    subscriptionId,
    uuid,
    FacebookPixelEvents.SUBSCRIBE,
    currency,
  )

  if (trialPeriodDays) {
    handleLogFacebookPixelEvent(
      trialPrice,
      subscriptionId,
      uuid,
      FacebookPixelEvents.START_TRIAL,
      currency,
    )
  }

  handleLogPurchaseCompleted({
    productId,
    price,
    paymentMethod,
    currency,
    screenName,
    isTrialActive,
  })
  handleLogGoogleAnalyticsEvent(
    subscriptionId,
    price,
    periodName,
    periodQuantity,
    currency,
    screenName,
  )
}
